<template>
  <v-card>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <v-text-field
            class="mt-5"
            label="Title"
            v-model.trim="doc.title"
            :rules="titleRules"
            type="text"
            placeholder="Title"
            id="title"
            required
          ></v-text-field>

          <v-textarea
            label="Description"
            v-model.trim="doc.description"
            type="text"
            placeholder="Description"
            id="description"
            rows="2"
          ></v-textarea>

          <v-select
            :items="headers"
            label="Column"
            :value="defaultSelected"
            v-model.trim="doc.model"
            item-text="title"
            item-value="model"
            :rules="selectRules"
          ></v-select>
        </v-col>
      </v-row>
      <slot></slot>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "RowForm",
  data() {
    return {
      items: [],
      titleRules: [(v) => !!v || "Title is required"],
      selectRules: [(v) => !!v || "Required"],
      search: null,

      defaultSelected: {
        title: "Other",
        model: "list5",
      },
    };
  },
  props: {
    doc: Object,
    headers: Array,
  },
  methods: {},
};
</script>
